<template>
  <div class=''>
    <div class="card-carousel-wrapper">
      <!-- <div class="card-carousel--nav__left" @click="moveCarousel(-1)" :disabled="atHeadOfList"></div> -->
      <span @click="moveCarousel(-1)" class="arrow arrow-l" :disabled="atHeadOfList"></span>
      <div class="card-carousel">
        <div class="card-carousel--overflow-container">
          <div class="card-carousel-cards" :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}">
            <div class="card-carousel--card " :class="{'active':xindex == index}" v-for="(item,index) in realDevList">
              <div class="card-carousel--card--footer " @click="chageCard(item,index)">
                <div class="card-carousel--card-top">
                  <!-- <span v-if="item.state==1" class="normal">正常</span>
                  <span v-if="item.state==2" class="abnormal">异常</span>
                  <span v-if="item.state==3" class="urgent">紧急</span>
                  <span v-if="item.state==4" class="offline">离线</span> -->
                  <img class="fl" v-if="item.state==1" src="../../../../static/img/normal.png" alt="">
                  <img class="fl" v-if="item.state==2" src="../../../../static/img/abnormal.png" alt="">
                  <img class="fl" v-if="item.state==3" src="../../../../static/img/urgent.png" alt="">
                  <img class="fl" v-if="item.state==4" src="../../../../static/img/offline.png" alt="">
                  <span>更新于</span><br>
                  <time>{{item.updateTime}}</time>
                </div>
                <p class="list-title">{{item.aliasName}} </p>
                <p class="list-date">
                  <span class="attr-name">{{item.attrName}}：</span>{{item.value}}{{item.unit}}</p>
                <p class="list-date">
                  <span class="attr-name">设备名称：</span>{{item.devName}}</p>
                <p class="list-date" :title="item.devId">
                  <span class="attr-name">设备编号：</span>{{item.devId}}</p>
                <!-- <div class="dev-name">
                  <p>采集设备名称</p>
                  <p>{{item.devId}}</p>
                </div> -->

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="card-carousel--nav__right" @click="moveCarousel(1)" :disabled="atEndOfList"></div> -->
      <span class="arrow arrow-r" @click="moveCarousel(1)" :disabled="atEndOfList"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    realDevList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      currentOffset: 0,
      windowSize: 5,
      paginationFactor: 245,
      xindex: 0
    };
  },
  created() {},
  computed: {
    atEndOfList() {
      return (
        this.currentOffset <=
        this.paginationFactor * -1 * (this.realDevList.length - this.windowSize)
      );
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    }
  },
  methods: {
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
    chageCard(item, index) {
      this.xindex = index;
      this.$emit("chageCard", item);
    }
  }
};
</script>
<style lang='scss' scoped>
.card-carousel-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  .arrow {
    cursor: pointer;
    width: 40px;
    height: 40px;
    // line-height: 40px;
    // background-color: rgba(204, 204, 204, 0.5);
    // border-radius: 0px 2px 2px 0px;
		// color: #fff;
		background: url("../../../../static/img/arrow.png");
    position: absolute;
    bottom: 115px;
    text-align: center;
    &.arrow-l {
      left: 5px;
    }
    &.arrow-r {
			right: 10px;
			transform: rotate(180deg);
    }
  }
}
.card-carousel-wrapper .arrow[disabled]{
	opacity: 0.2;
}
.card-carousel {
  display: flex;
  justify-content: center;
  // width: 640px;
  width: 100%;
}
.card-carousel--overflow-container {
  overflow: hidden;
}
.card-carousel--nav__left,
.card-carousel--nav__right {
  display: inline-block;
  width: 15px;
  height: 15px;
  padding: 10px;
  box-sizing: border-box;
  border-top: 2px solid #42b883;
  border-right: 2px solid #42b883;
  cursor: pointer;
  margin: 0 10px;
  transition: transform 150ms linear;
  position: absolute;
}
.card-carousel--nav__left[disabled],
.card-carousel--nav__right[disabled] {
  opacity: 0.2;
  border-color: black;
}
.card-carousel--nav__left {
  transform: rotate(-135deg);
  left: 0;
}
.card-carousel--nav__left:active {
  transform: rotate(-135deg) scale(0.9);
}
.card-carousel--nav__right {
  transform: rotate(45deg);
  right: 0;
}
.card-carousel--nav__right:active {
  transform: rotate(45deg) scale(0.9);
}

.card-carousel-cards {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);
}
.card-carousel-cards .card-carousel--card {
  margin: 0 10px;
  cursor: pointer;
  height: 215px;
  color: #fff;
  background-color: #47619a;
  border-radius: 4px;
  z-index: 3;
  padding: 20px 10px 10px 12px;
  margin: 0 10px;
  border: solid 1px #47619a;
  position: relative;
  text-align: center;

  &:hover {
    border: solid 1px #fff;
  }
  &.active {
    border: solid 1px #fff;
    background-color: #224794;
  }
  p {
    margin: 0;
    margin-left: 10px;
    color: #fff;
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 18px;
    text-align: left;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .normal {
    // position: absolute;
    // top: 0;
    // left: 0;
    padding: 5px 8px;
    color: #fff;
    background-color: #19bfbd;
    border-radius: 1px 0px 2px 0px;
    &.abnormal {
      background-color: #f9b83f;
    }
    &.urgent {
      background-color: #ff3300;
    }
  }
  .list-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
    margin-top: 15px;
    .list-date {
      color: #666666;
      .attr-name {
        font-size: 12px;
        color: #a4dcf5;
      }
    }
  }
  time {
    font-family: "Microsoft YaHei";
    font-size: 12px;
    text-align: center;
  }
  .dev-name {
    background-color: #f8f8f8;
    padding: 10px 0;
    margin-bottom: 10px;
    p {
      font-size: 16px;
      color: #666666;
      line-height: 30px;
      margin-bottom: 0;
    }
  }
}
.card-carousel-cards .card-carousel--card:first-child {
  margin-left: 0;
}
.card-carousel-cards .card-carousel--card:last-child {
  margin-right: 0;
}
.card-carousel-cards .card-carousel--card span{
	margin-top: 10px;
}
.card-carousel-cards .card-carousel--card img {
	vertical-align: bottom;
	margin-right: 10px;
  // border-top-left-radius: 4px;
  // border-top-right-radius: 4px;
  // transition: opacity 150ms linear;
  // user-select: none;
}
// .card-carousel-cards .card-carousel--card img:hover {
//   opacity: 0.5;
// }
.card-carousel-cards .card-carousel--card--footer {
  width: 200px;
  // border-top: 0;
	// padding: 7px 15px;
	.card-carousel--card-top{
		overflow: hidden;
		text-align: left;
	}
}
.card-carousel-cards .card-carousel--card--footer p {
  // padding: 3px 0;
  // margin: 0;
  // margin-bottom: 2px;
  // font-size: 19px;
  // font-weight: 500;
  // color: #2c3e50;
  // user-select: none;
}
.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2) {
  // font-size: 12px;
  // font-weight: 300;
  // padding: 6px;
  // background: rgba(40, 44, 53, 0.06);
  // display: inline-block;
  // position: relative;
  // margin-left: 4px;
  // color: #666a73;
}
.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2):before {
  // content: "";
  // float: left;
  // position: absolute;
  // top: 0;
  // left: -12px;
  // width: 0;
  // height: 0;
  // border-color: transparent rgba(40, 44, 53, 0.06) transparent transparent;
  // border-style: solid;
  // border-width: 12px 12px 12px 0;
}
.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2):after {
  // content: "";
  // position: absolute;
  // top: 10px;
  // left: -1px;
  // float: left;
  // width: 4px;
  // height: 4px;
  // border-radius: 2px;
  // background: white;
  // box-shadow: -0px -0px 0px #004977;
}

// h1 {
//   font-size: 3.6em;
//   font-weight: 100;
//   text-align: center;
//   margin-bottom: 0;
//   color: #42b883;
// }
</style>
